import { PdfViewer } from '@carvana/purchase-components';
import PropTypes from 'prop-types';
import React, { useLayoutEffect, useRef, useState } from 'react';

const PdfPreview = props => {
  const { fileUrl, gutter, ...rest } = props;

  const elementRef = useRef(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const handleWindowResize = () => {
      const offsetWidth = elementRef.current.offsetWidth;

      if (width !== offsetWidth) {
        setWidth(elementRef.current.offsetWidth);
      }
    };

    window.addEventListener('resize', handleWindowResize);

    handleWindowResize();

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return (
    <div ref={elementRef} {...rest}>
      <PdfViewer file={fileUrl} width={width} gutter={gutter} />
    </div>
  );
};

PdfPreview.propTypes = {
  fileUrl: PropTypes.string.isRequired,
  gutter: PropTypes.number
};

PdfPreview.defaultProps = {
  gutter: 0
};

export default PdfPreview;
